import actions from './actions'
import getters from './getters'
import mutations from './mutations'

import header from './modules/header'
import Train from './modules/Train'
import RentalCar from './modules/RentalCar'
import Refreshment from './modules/Refreshment'
import Bus from './modules/Bus'
import Taxi from './modules/Taxi'
import Home from './modules/Home'
import Flight from './modules/Flight'
import RebookCanx from './modules/RebookCanx'
import MessagesList from './modules/MessagesList'
import NpsPage from './modules/NpsPage'
import VirtualCreditCardDetail from './modules/VirtualCreditCardDetail'
import DownloadAllVoucher from './modules/DownloadAllVoucher'
import PaxContactDetail from './modules/PaxContactDetail'
import SelectManualService from './modules/SelectManualService'
import ServiceRefreshment from './modules/ServiceRefreshment'
import FlightNextDay from './modules/FlightNextDay'
import FlyToDay from './modules/FlyToDay'
import OverbookedPassenger from './modules/OverbookedPassenger'
import HotelBook from './modules/HotelBook'
import SelectService from './modules/SelectService'
import HotelList from './modules/HotelList'
import SelectRoom from './modules/SelectRoom'
import VirtualHelpdesk from './modules/VirtualHelpdesk'
import CancelHotelRoom from './modules/CancelHotelRoom'
import PaxContactConfirm from './modules/PaxContactConfirm'
import InviteTravelTogether from './modules/InviteTravelTogether'
import PassengerInviteList from './modules/PassengerInviteList'
import ConfirmVirtualHelpdesk from './modules/ConfirmVirtualHelpdesk'
import ShareUpdate from './modules/ShareUpdate'
import InfoFlightUpdate from './modules/InfoFlightUpdate'
import MyDocument from './modules/MyDocument'
import ShareTaxi from './modules/ShareTaxi'
import UpdatePhoneNumber from './modules/UpdatePhoneNumber'
import MonetaryCompensation from './modules/MonetaryCompensation'
import MealPlan from './modules/MealPlan'
const state = {
  airline: {},
  lang: {},
  pax: {},
  isInfoFlightPage: false,
  direction: 'ltr',
  title: {
    Bus: {},
    DownloadAllVoucher: {},
    Error: {},
    Flight: {},
    FlightNextDay: {},
    FlyToDay: {},
    HotelBook: {},
    HotelList: {},
    Message: {},
    MessageDetail: {},
    MessagesList: {},
    NpsPage: {},
    OverbookedPassenger: {},
    PassengerDetail: {},
    PaxContactDetail: {},
    PaxContactConfirm: {},
    RebookCanx: {},
    RebookDly: {},
    Refreshment: {},
    RentalCar: {},
    SelectManualService: {},
    SelectRoom: {},
    SelectService: {},
    ServiceAcceptance: {},
    ServiceOptionRefund: {},
    ServiceOptionRouting: {},
    ServiceRefreshment: {},
    Taxi: {},
    TaxiCreditcard: {},
    Train: {},
    VirtualCreditCardDetail: {},
    VirtualHelpdesk: {},
    WaitRebook: {},
    Home: {},
    Privacy: {},
    Disclaimer: {},
    Impressum: {},
    Welcome: {},
    ShareTaxi: {},
    UpdatePhoneNumber: {}
  },
  internalCmtId: 0,
  paxsGroup: {},
  isConfirmYet: false,
  validGGApi: true
  // curPaxInfo: {}
}

const mainStore = {
  modules: {
    header,
    Train,
    RentalCar,
    Refreshment,
    Bus,
    Taxi,
    Home,
    Flight,
    RebookCanx,
    MessagesList,
    NpsPage,
    VirtualCreditCardDetail,
    DownloadAllVoucher,
    PaxContactDetail,
    SelectManualService,
    ServiceRefreshment,
    FlightNextDay,
    FlyToDay,
    OverbookedPassenger,
    HotelBook,
    SelectService,
    HotelList,
    SelectRoom,
    CancelHotelRoom,
    PaxContactConfirm,
    InviteTravelTogether,
    PassengerInviteList,
    VirtualHelpdesk,
    ConfirmVirtualHelpdesk,
    ShareUpdate,
    InfoFlightUpdate,
    MyDocument,
    ShareTaxi,
    UpdatePhoneNumber,
    MonetaryCompensation,
    MealPlan
  },
  state,
  actions,
  getters,
  mutations
}
export default mainStore
